// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + {"121":"vendor","524":"app"}[chunkId] + "." + {"121":"e70df6028e93252a1a94","524":"575cbc02c97448b63ec1"}[chunkId] + ".css";
};